import styled from 'styled-components';

export const InfoSectionWrapper = styled.div<{ variant: 'light' | 'dark' }>`
  position: relative;
  padding: 48px 24px;
  background: ${props => props.variant === 'dark'
    ? 'rgba(0, 0, 0, 0.3)'
    : 'rgba(255, 255, 255, 0.05)'};
  border-radius: 12px;
  margin-bottom: 32px;
  backdrop-filter: blur(10px);
  border: 1px solid ${props => props.variant === 'dark'
    ? 'rgba(255, 255, 255, 0.1)'
    : 'rgba(255, 255, 255, 0.2)'};

  @media (min-width: 768px) {
    padding: 64px 48px;
  }
`;
